import { apiFetch } from "../utils/apiClient";
const source_id = Number(process.env.REACT_APP_SOC_ID || 1);

export const getAffrodablePlans = (data) => {
    
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/health/get-plan-premiums/affordable-health-cover`, {
        method: 'POST',
        body: JSON.stringify({ ...data, source_id}),
        headers: { 'Content-Type': 'application/json' },
      });
      return val;
    } catch (error) {
      console.error('Error in getAffrodablePlans:', error);
      throw error;
    }
  };
};

export const getQuoteAffordable  = (data) => {
    
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/health/get-quotation/affordable-health-cover`, {
        method: 'POST',
        body: JSON.stringify({ ...data, source_id }),
        headers: { 'Content-Type': 'application/json' },
      });
      return val;
    } catch (error) {
      console.error('Error in getQuote:', error);
      throw error;
    }
  };
};

export const addPolicyAffordable = (data) => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(dispatch, `${process.env.REACT_APP_API_URL}/api/v1/health/add-policy/affordable-health-cover`, {
        method: 'POST',
        body: JSON.stringify({ ...data, source_id }),
        headers: { 'Content-Type': 'application/json' },
      });
      return val;
    } catch (error) {
      console.error('Error in addPolicy:', error);
      throw error;
    }
  };
};